import React from "react";

export const AdjustFees: React.FunctionComponent = (props) => {
  return <>Adjust Fees</>;
};
